module.exports = __webpack_public_path__ + "media/images/background/4-90e75b49b3077da6c9c7a23b4ce1249b.jpg";